import { render, staticRenderFns } from "./CategoryTypesSelect.vue?vue&type=template&id=f43004a8&scoped=true&lang=pug"
import script from "./CategoryTypesSelect.vue?vue&type=script&lang=js"
export * from "./CategoryTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43004a8",
  null
  
)

export default component.exports